import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import './Toast.css';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};

let toastCounter = 0;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 5000) => {
    const id = `${Date.now()}-${++toastCounter}`;
    setToasts(prev => [...prev, { id, message, type, exiting: false }]);

    setTimeout(() => {
      setToasts(prev =>
        prev.map(t => (t.id === id ? { ...t, exiting: true } : t))
      );
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, 250);
    }, duration);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev =>
      prev.map(t => (t.id === id ? { ...t, exiting: true } : t))
    );
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 250);
  }, []);

  const success = useCallback((msg, dur) => addToast(msg, 'success', dur), [addToast]);
  const error = useCallback((msg, dur) => addToast(msg, 'error', dur), [addToast]);
  const warning = useCallback((msg, dur) => addToast(msg, 'warning', dur), [addToast]);
  const info = useCallback((msg, dur) => addToast(msg, 'info', dur), [addToast]);

  const contextValue = useMemo(() => ({ success, error, warning, info }), [success, error, warning, info]);

  const ICONS = {
    success: '\u2714',
    error: '\u2716',
    warning: '\u26A0',
    info: '\u2139',
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <div className="p-toast-container">
        {toasts.map(toast => (
          <div
            key={toast.id}
            className={`p-toast ofself-float-plate p-toast--${toast.type}${toast.exiting ? ' p-toast--exit' : ''}`}
          >
            <span className="p-toast__icon">{ICONS[toast.type]}</span>
            <span className="p-toast__message">{toast.message}</span>
            <button
              className="btn p-toast__close"
              onClick={() => removeToast(toast.id)}
              type="button"
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
